import axios from 'axios';

export default (openbetLoginUrl) =>
  axios.get(openbetLoginUrl, {
    withCredentials: true,
  });
